import React from 'react'
import { Switch, Route, useRouteMatch } from 'react-router-dom'
import ArticleBrowser from './ArticleBrowser'
import ArticleViewer from './ArticleViewer'
import ArticleEditor from './ArticleEditor'
import ArticleManager from './ArticleManager'

const pageStyle = {
  backgroundColor: '#f5f6fa',
  minHeight: 'calc(100vh - 64px)',
  width: '100%'
}

const KnowledgeBasePage = (props) => {
  const { path } = useRouteMatch()

  return (
    <div style={pageStyle}>
      <Switch>
        <Route exact path={path} render={() => <ArticleBrowser {...props} />} />
        <Route path={`${path}/manage`} render={() => <ArticleManager {...props} />} />
        <Route path={`${path}/create`} render={() => <ArticleEditor {...props} />} />
        <Route path={`${path}/edit/:id`} render={(routeProps) =>
          <ArticleEditor articleId={routeProps.match.params.id} {...props} />
        } />
        <Route path={`${path}/article/:slug`} render={(routeProps) =>
          <ArticleViewer slug={routeProps.match.params.slug} {...props} />
        } />
      </Switch>
    </div>
  )
}

export default KnowledgeBasePage
